import { render } from "./Shimmer.vue?vue&type=template&id=2629ffa8&scoped=true"
import script from "./Shimmer.vue?vue&type=script&lang=js"
export * from "./Shimmer.vue?vue&type=script&lang=js"

import "./Shimmer.vue?vue&type=style&index=0&id=2629ffa8&scoped=true&lang=css"

import exportComponent from "/Users/bilawal/Sites/bizrar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2629ffa8"]])

export default __exports__